export class DeepCopy {
    
    static from (data) {
        return JSON.parse(JSON.stringify(data));
    }
}